import { useState, useCallback } from "react";
import axios from "axios";

export function useUploadDocument(
  sessionId: string | undefined,
  fetchSessionInfo: () => Promise<void>,
  setScreenshot: (s: string | null) => void
) {
  const [uploadError, setUploadError] = useState<string | null>(null);

  const handleUpload = useCallback(
    async (imageSrc: string, filename: string = "capture.jpg") => {
      if (!sessionId) return;
      try {
        const blob = await (await fetch(imageSrc)).blob();

        const formData = new FormData();
        formData.append("file", blob, filename);

        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await fetchSessionInfo();
        setScreenshot(null);
      } catch (err) {
        console.error("Upload failed:", err);
        setUploadError("Échec de l'envoi. Veuillez réessayer.");
      }
    },
    [sessionId, fetchSessionInfo, setScreenshot]
  );

  return { handleUpload, uploadError, setUploadError };
}
